import { Vue, Component } from 'vue-property-decorator';
import { WmsLayout } from '../components/layout/layout';

@Component({
	components: {
		WmsLayout
	},
})
export class BasePage extends Vue {
}

export default BasePage;
